import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const navigationApiService = createApi({
  reducerPath: 'navigationApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/navigation/'),
  tagTypes: ['Paths', 'Landmarks', 'Graph'],
  endpoints: (builder) => ({
    // Paths
    getPaths: builder.query({
      query: (args) => {
        let params = queryParams(args)
        return `paths${params}`
      },
      providesTags: ['Paths'],
      keepUnusedDataFor: 0
    }),
    
    getPath: builder.query({
      query: (id) => `paths/${id}`,
      providesTags: ['Paths'],
      keepUnusedDataFor: 0
    }),
    
    createPath: builder.mutation({
      query: (payload) => ({
        url: 'paths',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['Paths', 'Graph']
    }),
    
    updatePath: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `paths/${id}`,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['Paths', 'Graph']
    }),
    
    deletePath: builder.mutation({
      query: (id) => ({
        url: `paths/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Paths', 'Graph']
    }),
    
    // Landmarks
    getLandmarks: builder.query({
      query: (args) => {
        let params = queryParams(args)
        return `landmarks${params}`
      },
      providesTags: ['Landmarks'],
      keepUnusedDataFor: 0
    }),
    
    getLandmark: builder.query({
      query: (id) => `landmarks/${id}`,
      providesTags: ['Landmarks'],
      keepUnusedDataFor: 0
    }),
    
    createLandmark: builder.mutation({
      query: (payload) => ({
        url: 'landmarks',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['Landmarks', 'Graph']
    }),
    
    updateLandmark: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `landmarks/${id}`,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['Landmarks', 'Graph']
    }),
    
    deleteLandmark: builder.mutation({
      query: (id) => ({
        url: `landmarks/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Landmarks', 'Graph']
    }),
    
    // Graph operations
    rebuildGraph: builder.mutation({
      query: () => ({
        url: 'graph/build',
        method: 'POST'
      }),
      invalidatesTags: ['Graph']
    }),
    
    getGraphStats: builder.query({
      query: () => 'graph/stats',
      providesTags: ['Graph'],
      keepUnusedDataFor: 0
    }),
    
    // Route testing
    calculateRoute: builder.mutation({
      query: (payload) => ({
        url: 'route',
        method: 'POST',
        body: payload
      })
    })
  })
})

export const {
  useGetPathsQuery,
  useGetPathQuery,
  useCreatePathMutation,
  useUpdatePathMutation,
  useDeletePathMutation,
  useGetLandmarksQuery,
  useGetLandmarkQuery,
  useCreateLandmarkMutation,
  useUpdateLandmarkMutation,
  useDeleteLandmarkMutation,
  useRebuildGraphMutation,
  useGetGraphStatsQuery,
  useCalculateRouteMutation
} = navigationApiService
